import React, { useEffect, useState, useRef} from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { BaseUrl } from "../../helper/BaseUrl";
import axios from "axios";

export default function HomeEnroll({mainClass="", btnClass="", btn2Class="", initialData}) {
    const [allData, setAllData] = useState(initialData || []);
    const sliderRef = useRef(null);

    useEffect(() => {
    const dataFetcher = async () => {
        try {
        const response = await axios.get(`${BaseUrl}/api/branches`);
        // console.log("API response:", response.data);
        setAllData(response.data.branch || []); 
        } catch (error) {
        console.error("Data fetch error:", error);
        }
    };

    dataFetcher();
    }, []);


    if (!allData) {
        return null;
    }
    
    const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 1300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    cssEase: "ease",
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 599,
        settings: { slidesToShow: 1 },
      },
    ],
    };

  return (
    <>
    <div className={`home-enroll ${mainClass}`} >
        <div className="container">
            <div className="row align-items-center">  

                <div className="col-lg-4 col-md-5">
                    <h4 className="heading">Interested in enrolling your child?</h4>
                    <Link to={"/apply-now"} className={btnClass? `default-btn ${btnClass}` : "default-btn red-default"}>
                        <div><span>Apply Now</span><span>Apply Now</span></div>
                    </Link>
                    <Link to={"/contact"} className={`default-btn ${btn2Class}`}>
                        <div><span>Contact us</span><span>Contact us</span></div>
                    </Link>
                </div>

                <div className="col-lg-8 col-md-7">
                    <Slider {...settings} ref={sliderRef} className="enroll-slider">
                        {allData.map((data, index) => (
                        <div className="school-detailbox" key={index}>
                            <img src={`${BaseUrl}${data.thumbnail}`} className="img-responsive" alt="school" loading="lazy"/>
                            <span>{data.name}</span>
                            <ul>
                                <li><img src="/image/location.svg" alt="location"/>
                                    <p>{data.address}</p>
                                </li>   
                                <li>
                                    <img src="/image/phone.svg" alt="phone"/>
                                    <a href={`tel:${data.contact}`}>{data.contact}</a>
                                </li>
                                <li>
                                    <img src="/image/mail.svg" alt="email"/>
                                    <a href={`mailto:${data.email}`}>{data.email}</a>
                                </li>
                            </ul>
                        </div>
                        ))}
                    </Slider>

                    {/* <Slider {...settings} ref={sliderRef} className="enroll-slider">
                        <div className="school-detailbox">
                            <img src="/image/school-1.webp" className="img-responsive" alt="school" loading="lazy"/>
                            <span>Sector-C</span>
                            <ul>
                                <li><img src="/image/location.svg" alt="location"/>
                                    <p>Sector-C, Ansal Api, Sushant Golf City, Lucknow</p>
                                </li>   
                                <li><img src="/image/phone.svg" alt="phone"/>
                                    <Link to="tel:+91 9876543210">+91 987 654 3210</Link>
                                </li>
                                <li><img src="/image/mail.svg" alt="email"/>
                                    <Link to="mailto:lpssectord@lpgs.co.in">lpssectord@lpgs.co.in</Link>
                                </li>
                            </ul>
                        </div>
                     
                        <div className="school-detailbox">
                            <img src="/image/school-2.webp" className="img-responsive" alt="school" loading="lazy"/>
                            <span>Sector-D</span>
                            <ul className="list-unstyled">
                                <li><img src="/image/location.svg" alt="location"/>
                                    <p>Sector-D, Lda Colony, Kanpur Road, Lucknow</p>
                                </li>   
                                <li><img src="/image/phone.svg" alt="phone"/>
                                    <Link to="tel:+91 9876543210">+91 987 654 3210</Link>
                                </li>
                                <li><img src="/image/mail.svg" alt="email"/>
                                    <Link to="mailto:lpssectord@lpgs.co.in">lpssectord@lpgs.co.in</Link>
                                </li>
                            </ul>
                        </div>

                        <div className="school-detailbox">
                            <img src="/image/school-3.webp" className="img-responsive" alt="school" loading="lazy"/>
                            <span>Sector-I</span>
                            <ul className="list-unstyled">
                                <li><img src="/image/location.svg" alt="location"/>
                                    <p>Sector-I, Lda Colony, Kanpur Road, Lucknow</p>
                                </li>   
                                <li><img src="/image/phone.svg" alt="phone"/>
                                    <Link to="tel:8188037816">8188037816</Link>
                                </li>
                                <li><img src="/image/mail.svg" alt="email"/>
                                    <Link to="mailto:principal_sv@lpsc.co.in">principal_sv@lpsc.co.in</Link>
                                </li>
                            </ul>
                        </div>

                        <div className="school-detailbox">
                            <img src="/image/school-4.webp" className="img-responsive" alt="school" loading="lazy"/>
                            <span>Sector-F</span>
                            <ul className="list-unstyled">
                                <li><img src="/image/location.svg" alt="location"/>
                                    <p>Sector-F, Sahara Estate Road, Jankipuram, Lucknow</p>
                                </li>   
                                <li><img src="/image/phone.svg" alt="phone"/>
                                    <Link to="tel:8188037816">8188037816</Link>
                                </li>
                                <li><img src="/image/mail.svg" alt="email"/>
                                    <Link to="mailto:principal_sv@lpsc.co.in">principal_sv@lpsc.co.in</Link>
                                </li>
                            </ul>
                        </div>

                        <div className="school-detailbox">
                            <img src="/image/school-5.webp" className="img-responsive" alt="school" loading="lazy"/>
                            <span>Ahiyaraipur</span>
                            <ul className="list-unstyled">
                                <li><img src="/image/location.svg" alt="location"/>
                                    <p>Ahiyaraipur, Raebareilly</p>
                                </li>   
                                <li><img src="/image/phone.svg" alt="phone"/>
                                    <Link to="tel:8188037816">8188037816</Link>
                                </li>
                                <li><img src="/image/mail.svg" alt="email"/>
                                    <Link to="mailto:principal_sv@lpsc.co.in">principal_sv@lpsc.co.in</Link>
                                </li>
                            </ul>
                        </div>

                        <div className="school-detailbox">
                            <img src="/image/school-6.webp" className="img-responsive" alt="school" loading="lazy"/>
                            <span>A-block</span>
                            <ul className="list-unstyled">
                                <li><img src="/image/location.svg" alt="location"/>
                                    <p>A-block, South City, Raebareilly Road, Lucknow</p>
                                </li>   
                                <li><img src="/image/phone.svg" alt="phone"/>
                                    <Link to="tel:8188037816">8188037816</Link>
                                </li>
                                <li><img src="/image/mail.svg" alt="email"/>
                                    <Link to="mailto:principal_sv@lpsc.co.in">principal_sv@lpsc.co.in</Link>
                                </li>
                            </ul>
                        </div>

                        <div className="school-detailbox">
                            <img src="/image/school-7.webp" className="img-responsive" alt="school" loading="lazy"/>
                            <span>Sector-B</span>
                            <ul className="list-unstyled">
                                <li><img src="/image/location.svg" alt="location"/>
                                    <p>Sector-B, Priyadarshini Nagar, Unnao</p>
                                </li>   
                                <li><img src="/image/phone.svg" alt="phone"/>
                                    <Link to="tel:8188037816">8188037816</Link>
                                </li>
                                <li><img src="/image/mail.svg" alt="email"/>
                                    <Link to="mailto:principal_sv@lpsc.co.in">principal_sv@lpsc.co.in</Link>
                                </li>
                            </ul>
                        </div>

                        <div className="school-detailbox">
                            <img src="/image/school-8.webp" className="img-responsive" alt="school" loading="lazy"/>
                            <span>Pragatipuram Colony</span>
                            <ul className="list-unstyled">
                                <li><img src="/image/location.svg" alt="location"/>
                                    <p>Pragatipuram Colony, Raebareilly</p>
                                </li>   
                                <li><img src="/image/phone.svg" alt="phone"/>
                                    <Link to="tel:8188037816">8188037816</Link>
                                </li>
                                <li><img src="/image/mail.svg" alt="email"/>
                                    <Link to="mailto:principal_sv@lpsc.co.in">principal_sv@lpsc.co.in</Link>
                                </li>
                            </ul>
                        </div>

                        <div className="school-detailbox">
                            <img src="/image/school-9.webp" className="img-responsive" alt="school" loading="lazy"/>
                            <span>Sector-C</span>
                            <ul className="list-unstyled">
                                <li><img src="/image/location.svg" alt="location"/>
                                    <p>Sector-C, Priyadarshini Nagar, Unnao</p>
                                </li>   
                                <li><img src="/image/phone.svg" alt="phone"/>
                                    <Link to="tel:8188037816">8188037816</Link>
                                </li>
                                <li><img src="/image/mail.svg" alt="email"/>
                                    <Link to="mailto:principal_sv@lpsc.co.in">principal_sv@lpsc.co.in</Link>
                                </li>
                            </ul>
                        </div>

                        <div className="school-detailbox">
                            <img src="/image/school-10.webp" className="img-responsive" alt="school" loading="lazy"/>
                            <span>Eldeco Samridhi</span>
                            <ul className="list-unstyled">
                                <li><img src="/image/location.svg" alt="location"/>
                                    <p>Eldeco Samridhi, Udyan-ii, Raebareli Road, Lucknow</p>
                                </li>   
                                <li><img src="/image/phone.svg" alt="phone"/>
                                    <Link to="tel:8188037816">8188037816</Link>
                                </li>
                                <li><img src="/image/mail.svg" alt="email"/>
                                    <Link to="mailto:principal_sv@lpsc.co.in">principal_sv@lpsc.co.in</Link>
                                </li>
                            </ul>
                        </div>
                    </Slider> */}
                </div>

            </div>
        </div>
    </div>
    </>
  )
}
